{
  "pages": {
    "projects": {
      "title": "Projects"
    }
  },
  "components": {
    "projectsMenu": {
      "title": "Projects",
      "newProject": "New Project",
      "noTeams": {
        "title": "No teams found",
        "description": "Create a team to get started"
      },
      "projectNotFound": {
        "title_one": "No project found",
        "title_other": "No projects found",
        "description": "Create a project to get started"
      },
      "noProjectSelected": {
        "title": "No project selected",
        "description": "Create or select a project to get started"
      },
      "teamMoreMenu": {
        "label": "Team options"
      }
    },
    "projectHeader": {
      "start": "Start",
      "targetEnd": "Target End"
    },
    "projectDetails": {
      "edit": "Edit Project",
      "moreMenu": {
        "label": "More options"
      }
    },
    "projectsTable": {
      "columns": {
        "name": "Project name",
        "status": "Status",
        "team": "Team",
        "assignedTo": "Assigned to",
        "startDate": "Start date",
        "targetEndDate": "Target end date",
        "updatedAt": "Last updated"
      },
      "noData": {
        "title": "No projects found",
        "description": "There are no projects to display."
      }
    },
    "projectFormDialog": {
      "new": "New Project",
      "edit": "Edit Project",
      "submit": {
        "update": "Update Project",
        "create": "Create Project"
      },
      "fields": {
        "name": "Name",
        "status": "Status",
        "startDate": "Start Date",
        "targetEndDate": "Target End Date",
        "assignedTo": "Assigned To",
        "team": "Team"
      }
    },
    "tabs": {
      "overview": {
        "title": "Overview",
        "options": "Options",
        "cards": {
          "openTickets": "Open Tickets",
          "openTasks": "Open Tasks",
          "actionItems": "Action Items",
          "dueThisWeek": "Due This Week"
        },
        "dueTodayTickets": "Due Today - Tickets",
        "dueTodayTasks": "Due Today - Tasks"
      },
      "tasks": {
        "title": "Tasks",
        "new": "New Task",
        "edit": "Edit Task"
      },
      "actionItems": {
        "title": "Action Items",
        "new": "New Action Item"
      },
      "files": {
        "title": "Files",
        "new": "New File",
        "columns": {
          "fileName": "File Name",
          "fileOwner": "File Owner",
          "uploadDate": "Upload Date",
          "more": "More"
        },
        "actions": {
          "download": "Download",
          "downloadUnavailable": "Download unavailable",
          "preview": "Preview",
          "previewUnavailable": "Preview unavailable"
        }
      }
    },
    "projectFileUploadDialog": {
      "title": "Upload new files",
      "uploadSuccess": "Files uploaded successfully",
      "uploadError": "Failed to upload files",
      "partialUploadError": "{{successCount}} file(s) uploaded successfully, {{errorCount}} file(s) failed to upload",
      "supportedFormats": "Supported format: pdf, doc, docx, jpg, png, xls, xlsx, pptx, ppt, csv, txt",
      "fields": {
        "uploadFiles": {
          "label": "Upload files"
        },
        "uploadedDocuments": {
          "label": "Uploaded documents"
        }
      }
    }
  }
}
